if (!customElements.get('bestsellers-tabs')) {
    customElements.define('bestsellers-tabs',
        class CollectionSlider extends HTMLElement {
            constructor() {
                super();
                this.currentSliderInstance = null; // Keep track of the current slider instance
                this.initialize = this.initialize.bind(this);

                this.tabs = this.querySelectorAll('.collection_tabs__tab');
                this.sliders = this.querySelectorAll('.bestsellers-tabs__slider');

                document.addEventListener("DOMContentLoaded", this.initialize);
                window.addEventListener("resize", this.initialize);

                // Adding event listeners for each tab
                this.tabs.forEach(tab => {
                    tab.addEventListener('click', this.onTabClick.bind(this));
                });
            }

            initialize() {
                if (this.currentSliderInstance) {
                    this.currentSliderInstance.destroy(); // Destroy the previously initialized slider
                }

                const activeSlider = this.querySelector(".bestsellers-tabs__slider:not(.bestseller-tab-hidden)");

                if (activeSlider) {
                    this.initSlider(activeSlider); // Initialize the first visible slider on page load
                }
            }

            initSlider(sliderElement) {
                let options = {
                    classes: {
                        arrows: 'splide__arrows your-class-arrows',
                        arrow: 'splide__arrow your-class-arrow',
                        prev: 'splide__arrow--prev custom-prev',
                        next: 'splide__arrow--next custom-next',
                    },
                    perMove: 1,
                    perPage: 4,
                    drag: true,
                    pagination: true,
                    arrows: true,
                    mediaQuery: 'max',
                    breakpoints: {
                        950: {
                            perPage: 4
                        },
                        767: {
                            perPage: 2
                        },
                    }
                };

                // Initialize the slider with the passed element
                this.currentSliderInstance = new Splide(sliderElement, options).mount();
            }

            onTabClick(event) { 
                this.tabs.forEach(tab => tab.classList.remove('collection_tabs__tab-active'));
                event.currentTarget.classList.add('collection_tabs__tab-active');

                const tabIndex = event.currentTarget.getAttribute('data-slider-index');

                this.sliders.forEach(slider => {
                    const sliderIndex = slider.getAttribute('data-slider-index');

                    if (sliderIndex === tabIndex) {
                        slider.classList.remove('bestseller-tab-hidden');
                        if (this.currentSliderInstance) {
                            this.currentSliderInstance.destroy();
                        }
                        this.initSlider(slider); 
                    } else {
                        slider.classList.add('bestseller-tab-hidden');
                    }
                });
            }
        });
}
